import './scss/app'

import 'jquery.scrollto/jquery.scrollTo'
import 'magnific-popup/dist/jquery.magnific-popup'
import './js/vendor/flyLabel'
import './js/vendor/cookie'
import 'jquery-mask-plugin'
import scrollMonitor from 'scrollmonitor'

const app = {
  ui: {},
}

app.ui.header = require('./js/modules/header')
app.ui.siteNav = require('./js/modules/site-nav')
app.ui.home = require('./js/modules/home')
app.ui.forms = require('./js/modules/forms')
app.ui.formEmbed = require('./js/modules/form-embed')
app.ui.faqs = require('./js/modules/faqs')
app.ui.clientLogos = require('./js/modules/client-logos')
app.ui.serviceCallout = require('./js/modules/service-callout')
app.ui.serviceMap = require('./js/modules/service-map')
app.ui.advantages = require('./js/modules/advantages')
app.ui.technology = require('./js/modules/technology')
app.ui.industryLanding = require('./js/modules/industry-landing')
app.ui.ourService = require('./js/modules/our-service')
app.ui.informationalPacketForm = require('./js/modules/informational-packet-form')
app.ui.careers = require('./js/modules/careers')
app.ui.newsroom = require('./js/modules/newsroom')
app.ui.animation = require('./js/modules/animation')
app.ui.landingForm = require('./js/modules/landing-form')
app.ui.parallax = require('./js/modules/parallax')
app.ui.modal = require('./js/modules/modal')

$(window).on('load', () => {
  $.scrollTo(document.body, 200)

  for (const key of Object.keys(app.ui)) {
    const module = app.ui[key].default

    if (typeof module.run !== 'undefined' && typeof module.can !== 'undefined') {
      if (module.can === true || module.can()) {
        module.run()
      }
    }
  }
})

$(window).on('resize', () => {
  scrollMonitor.recalculateLocations()
})

$(window).on('load', scrollMonitor.update)
